import { useApi, useBalloonEventsMetadata } from 'react-ui';
import React, { useEffect } from 'react';

export function SystemDownWarning() {
    const { metadata } = useBalloonEventsMetadata();

    if (metadata) {
        return null;
    }

    return <div className='absolute top-10 left-10 bg-yellow-400 rounded p-4 z-[100]'>
        System is down for maintenance. Please try again later.
    </div>
}